const splitReferenceTokens = (value: string): string[] =>
  value
    .split("/")
    .map((item) => item.trim())
    .filter(Boolean);

const getTypeFallbackLabel = (
  type: string,
  defaultLanguage: string = "ESP"
): string => {
  const normalized = (type || "").toLowerCase();

  if (normalized === "color") return "Color";
  if (normalized === "talla" || normalized === "size") {
    return defaultLanguage === "ENG" ? "Size" : "Talla";
  }

  return type;
};

export const getReferenceDisplayText = (
  product: any,
  defaultLanguage: string = "ESP"
): string | null => {
  if (!(product?.references && product.references.length > 0)) return null;

  const selectedReference = product.references[0]?.data ?? product.references[0];
  const baseTitle =
    typeof selectedReference?.title === "string"
      ? selectedReference.title.trim()
      : "";
  const rawReference =
    typeof selectedReference?.name === "string" &&
    selectedReference.name.trim() !== ""
      ? selectedReference.name.trim()
      : baseTitle;

  if (!rawReference) return null;

  const setupReferences = Array.isArray(product?.productData?.setupReferences)
    ? product.productData.setupReferences
    : [];

  if (setupReferences.length === 0) {
    return baseTitle || rawReference;
  }

  const tokens = splitReferenceTokens(rawReference);
  const result: string[] = [];

  setupReferences.forEach((setupRef: any, index: number) => {
    const label =
      typeof setupRef?.name === "string" && setupRef.name.trim() !== ""
        ? setupRef.name.trim()
        : getTypeFallbackLabel(String(setupRef?.type || ""), defaultLanguage);

    if (!label) return;

    let selectedValue = tokens[index] || "";

    if (!selectedValue && Array.isArray(setupRef?.values)) {
      selectedValue =
        setupRef.values.find((value: string) =>
          tokens.includes(String(value).trim())
        ) || "";

      if (!selectedValue && setupReferences.length === 1) {
        selectedValue = baseTitle || rawReference;
      }
    }

    if (!selectedValue && setupReferences.length === 1) {
      selectedValue = baseTitle || rawReference;
    }

    if (selectedValue) {
      result.push(`${label}: ${selectedValue}`);
    }
  });

  if (result.length > 0) return result.join(" | ");

  return baseTitle || rawReference;
};

